"use client";

import { FLOORS, PROPERTY_TYPES } from "@/features/quote/shared/quote-config";
import { StepHeading } from "@/features/quote/ui/StepHeading";
import { StepNav } from "@/features/quote/ui/StepNav";
import { useWizard } from "@/features/quote/ui/wizard-context";
import { labelClass } from "@/shared/ui/form/field-styles";
import { RadioCards } from "@/shared/ui/form/RadioCards";

export function PropertyStep() {
  const { state, setState, autoAdvance, goToStep, step, stepReady } = useWizard();

  return (
    <section>
      <StepHeading
        title="Hvilken type bolig?"
        body="Det hjælper os med at matche dig med firmaer der har erfaring med din boligtype."
      />
      <RadioCards
        options={PROPERTY_TYPES}
        value={state.propertyType}
        onChange={(v) => {
          setState((p) => ({
            ...p,
            propertyType: v,
            bbrPrefilled: { ...p.bbrPrefilled, propertyType: false },
          }));
          if (v !== "lejlighed") autoAdvance();
        }}
      />
      {state.bbrPrefilled.propertyType && (
        <p className="mt-2 text-[13px] text-ink-subtle">Hentet fra BBR - ret hvis nødvendigt.</p>
      )}

      {state.propertyType === "lejlighed" && (
        <div className="mt-8">
          <div className={labelClass}>Hvilken etage?</div>
          <RadioCards
            options={FLOORS}
            value={state.floor}
            onChange={(v) => {
              setState((p) => ({
                ...p,
                floor: v,
                bbrPrefilled: { ...p.bbrPrefilled, floor: false },
              }));
              autoAdvance();
            }}
            gridClassName="grid-cols-2 sm:grid-cols-3"
          />
          {state.bbrPrefilled.floor && (
            <p className="mt-2 text-[13px] text-ink-subtle">
              Hentet fra BBR - ret hvis nødvendigt.
            </p>
          )}
        </div>
      )}

      <StepNav
        onBack={() => goToStep(step - 1)}
        onNext={() => goToStep(step + 1)}
        nextEnabled={stepReady("property")}
        nextLabel="Næste →"
      />
    </section>
  );
}
